
//Import React Hooks
import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';


function ManagerMenu({ current }) {
    const navigate = useNavigate();

    return (

        <div className="manager-menu">
            <div className="manager-menu-top">
                <h3>Nestor Manager</h3>
            </div>
            <div className="manager-menu-bottom">
                <ul className="manager-menu-bottom-navbar">
                    <li onClick={_ => navigate(`/manager/clients`)} className={current === "clients" ? "current-page" : ""}>Clients</li>
                    <li onClick={_ => navigate(`/manager/reservations`)} className={current === "reservations" ? "current-page" : ""}> Réservations</li>
                    <li onClick={_ => navigate(`/manager`)} className={current === "calendar" ? "current-page" : ""}> Calendrier</li>
                    <li onClick={_ => navigate(`/manager/locations`)} className={current === "locations" ? "lien-locations-selected" : "lien-locations"}> Locations Matériel</li>
                </ul>
            </div>
        </div>
    );
}

export default ManagerMenu;